export var getArrayOfSelected = function getArrayOfSelected(selectedFolders) {
  var selected = [];
  for (var key in selectedFolders) {
    if (selectedFolders[key]) {
      selected.push(Number(key));
    }
  }
  return selected;
};